import { Pipe, PipeTransform } from '@angular/core';
import { LearningCenterService } from '../../learning-center.service';

@Pipe({name: 'userNameFromId'})
export class UserNameFromIdPipe implements PipeTransform {
    constructor (public lcService: LearningCenterService) {}

    transform(id: number, altName?: string, refresh?): string {
        let name = this.lcService.getUsersNameFromId(+id);

        if (name) return name;
        else {
            if (altName) return altName;
            else return 'Unknown user';
        }
    }
}

@Pipe({name: 'userAvatarFromId'})
export class UserAavatarFromIdPipe implements PipeTransform {
    constructor (public lcService: LearningCenterService) {}

    transform(id: number): string {
        let avatar = this.lcService.getUsersAvatarFromId(+id);

        if (avatar) return avatar;
        else return '';
    }
}

@Pipe({name: 'userEmailFromId'})
export class UserEmailFromIdPipe implements PipeTransform {
    constructor (public lcService: LearningCenterService) {}

    transform(id: number): string {
        let email = this.lcService.getUsersEmailFromId(+id);

        if (email) return email;
        else return '';
    }
}
